<div>
  <div class="user-content" :class="isError ? 'is-error': ''">
    <div class="user-list">
      <span v-if="!value">请选择</span>
      <a-tag v-else closable color="blue" @close.prevent="removeSelected">{{ valueName }}</a-tag>
    </div>
    <div @click="showModal" class="add-icon">
      <img src="../../assets/images/icon_add.png" alt="" />
    </div>
    <div class="zhezhao" @click="showModal" v-if="!valueName?.length>0"></div>
  </div>
</div>
